export default {
  type: 'email_logs',
  name: 'Email List Logs',
  description: 'Email list usage and error logs',
  search: {
    search: 'allEmailLogs',
    orderBy: {
      type: 'EmailLogsOrderBy',
      default: 'LOG_TIME_DESC'
    },
    fields: [
      { name: 'logTime', type: 'daterange', order: 'LOG_TIME' },
      [
        {
          name: 'emailList',
          type: 'select',
          width: 4,
          options: {
            lookup: 'allEmailLists',
            value: 'emailList',
            text: 'emailList',
            allowNull: true,
            nullText: 'All',
            params: [
              {
                field: 'orderBy',
                passArray: true,
                type: 'EmailListsOrderBy',
                default: 'EMAIL_LIST_ASC'
              }
            ]
          },
          order: 'EMAIL_LIST'
        },
        {
          name: 'action',
          type: 'select',
          width: 5,
          options: [
            { value: null, text: 'All' },
            { value: 'DoMessage', text: 'Received email' },
            { value: 'distribute', text: 'Moderation: allow distribution' },
            { value: 'reject', text: 'Moderation: reject distribution' },
            { value: 'get_bounce', text: 'Bounce Message Received' }
          ],
          order: 'ACTION'
        },
        {
          name: 'status',
          type: 'select',
          width: 3,
          options: [
            { value: null, text: 'All' },
            { value: 'success', text: 'Success' },
            { value: 'error', text: 'Error' }
          ],
          order: 'STATUS'
        }
      ],
      { name: 'userEmail', searchable: false, order: 'USER_EMAIL' },
      { name: 'targetEmail', searchable: false, order: 'TARGET_EMAIL' }
    ]
  }
}
